import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const selectSocialNetsSlice = createSelector(
  (state: RootState) => state.organizer.socialNets,
  (state) => state,
);

export const selectStatus = createSelector([selectSocialNetsSlice], (state) => ({
  isLoading: state.isLoading,
  isLoaded: state.isLoaded,
  isProcessing: state.isProcessing,
  process: state.process,
}));

export const selectSocialNets = createSelector([selectSocialNetsSlice], (state) => state.data);

export const selectSocialNetTournamentId = createSelector([selectSocialNetsSlice], (state) => state.tournamentId);
